import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { pl } from './local';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: pl,
    },
    fallbackLng: 'pl',
    lng: 'pl',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;